import React, { useState } from 'react';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import { useTranslation } from 'react-i18next';
import BaseButton, { IBaseButtonProps } from './_module/BaseButton';
import { useCreateUserFollowMutation } from '../../../graphql/mutation/userFollow/createUserFollowMutation';
import useNotification from '../_hook/useNotification';
import { useDeleteUserFollowsMutation } from '../../../graphql/mutation/userFollow/deleteUserFollowsMutation';

interface IProps extends IBaseButtonProps {
  text?: string;
  followedText?: string;
  followText?: string;
  userFollowId?: string;
  currentUserId?: string;
  followUserId?: string;
  followType?: string;
}

export default function ButtonFollow(props: IProps) {
  const {
    color,
    variant,
    onClick,
    text,
    size,
    disabled,
    fullWidth,
    followedText,
    followText,
    currentUserId,
    followUserId,
    followType,
    userFollowId,
  } = props;
  const [currentUserFollowId, setCurrentUserFollowId] = useState<
    string | undefined
  >(userFollowId);
  const { t } = useTranslation();
  const { notification } = useNotification();
  const [
    createUserFollowMutation,
    { loading: isCreatingUserFollow },
  ] = useCreateUserFollowMutation(
    `createdUserFollow {
				_id
				id
				type
				user
			}`,
    {
      onCompleted: (data) => {
        if (
          data &&
          data.createUserFollow &&
          data.createUserFollow.createdUserFollow
        ) {
          setCurrentUserFollowId(data.createUserFollow.createdUserFollow._id);
        }
      },
      onError: (e) => {
        notification.error(e.message);
      },
    }
  );

  const [
    deleteUserFollowsMutation,
    { loading: isDeletingUserFollows },
  ] = useDeleteUserFollowsMutation(`isSuccess`, {
    onCompleted: () => {
      setCurrentUserFollowId(undefined);
    },
    onError: (e) => {
      notification.error(e.message);
    },
  });

  async function onClickFollow() {
    if (currentUserId && followUserId && followType) {
      if (currentUserId === followUserId) {
        notification.error(t('are_you_following_yourself'));
      } else {
        await createUserFollowMutation({
          variables: {
            currentUserId,
            followUserId,
            followType,
          },
        });
      }
    }
  }

  async function onClickUnfollow() {
    if (currentUserFollowId) {
      await deleteUserFollowsMutation({
        variables: {
          _ids: [currentUserFollowId],
        },
      });
    }
  }

  return (
    <BaseButton
      color={color}
      fullWidth={fullWidth}
      disabled={disabled}
      variant={variant}
      onClick={async () => {
        if (onClick) {
          onClick();
        } else {
          if (currentUserFollowId) {
            if (!isDeletingUserFollows) {
              await onClickUnfollow();
            }
          } else {
            if (!isCreatingUserFollow) {
              await onClickFollow();
            }
          }
        }
      }}
      size={size}
      startIcon={
        currentUserFollowId ? (
          <StarIcon fontSize={size === 'small' ? 'small' : undefined} />
        ) : (
          <StarBorderIcon fontSize={size === 'small' ? 'small' : undefined} />
        )
      }
    >
      {currentUserFollowId ? followedText : followText}
      {text}
    </BaseButton>
  );
}
